var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEkata = function SvgEkata(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9444 5.35889V1.85772C18.9444 1.50672 18.6599 1.22217 18.3089 1.22217H3.6911C3.34009 1.22217 3.05554 1.50672 3.05554 1.85772V19.788C3.05554 20.139 3.34009 20.4236 3.6911 20.4236H18.3089C18.6599 20.4236 18.9444 20.139 18.9444 19.788V16.4553C18.9444 16.1043 18.6599 15.8197 18.3089 15.8197H8.80025C8.44924 15.8197 8.16469 15.5352 8.16469 15.1842V6.63C8.16469 6.279 8.44924 5.99445 8.80024 5.99445H18.3089C18.6599 5.99445 18.9444 5.7099 18.9444 5.35889Z",
    fill: "black",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73669 12.0963V9.4934C9.73669 9.1424 10.0212 8.85785 10.3723 8.85785H16.2876C16.6386 8.85785 16.9232 9.1424 16.9232 9.49341V12.0963C16.9232 12.4473 16.6386 12.7318 16.2876 12.7318H10.3723C10.0212 12.7318 9.73669 12.4473 9.73669 12.0963Z",
    fill: "black",
    fillOpacity: 0.45
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEkata);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ekata.0d3e4d12c37117a7d968b595ae7c5da8.svg";